import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {openModal, closeModal} from 'Skelet/src/modules/functions.js'
import ModalCreateFoodlog from './ModalCreateFoodlog.js'
import ModalCRUD from 'Skelet/src/components/ModalCRUD.js'


class Food extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "food_list", "GET", config.api_url+"/food?t="+this.props.session_token);
      this.props.fetchDataIfReady(config.api_token, "foodlog_list", "GET", config.api_url+"/foodlog?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "food_list", "GET", config.api_url+"/food?t="+nextProps.session_token);
      this.props.fetchDataIfUndefined(config.api_token, "foodlog_list", "GET", config.api_url+"/foodlog?t="+nextProps.session_token);
    }
  }

  render() {
    let foodlog_card = null, food_card = null, foodlogs = [], foodlog_data = this.props.apiData["foodlog_list"], food_data = this.props.apiData["food_list"];

    let foodlog_introcard = <div className="card" style={{background:"#15a033",color:"#fff"}}>"Begin met het bijhouden van wat je nu dagelijks eet, en maak daar een gewoonte van. Als je dit bijvoorbeeld twee weken doet, ben je al bewuster bezig met je eetgewoontes, en heb je meteen de eerste stap gezet naar een gezondere leefstijl."</div>;

    if(foodlog_data !== undefined && food_data !== undefined && food_data.data[0] !== undefined) {
      if(foodlog_data.data[0] !== undefined) {
        let grouped = {};
        for(let i = 0; i < foodlog_data.data.length; i++) {
          let item = foodlog_data.data[i];
          if(grouped[item.date] === undefined) {
            grouped[item.date] = [item];
          } else {
            grouped[item.date].push(item);
          }
        }

        for(let i = 0; i < Object.keys(grouped).length; i++) {
          let total_kj = 0.0;
          let food_items = grouped[Object.keys(grouped)[i]].map(function(item, i) {
            let food_item = food_data.data.find(function(food) {
              return food.id === item.food_id;
            });
            let portion_kj = item.food_grams * (food_item.energy_kj / 100);
            total_kj += portion_kj;
            return <div key={"11k"+i} style={{marginBottom:"12px"}}>
              <p>{item.food_grams}g <span style={{opacity:".7"}}>{food_item.name} ({food_item.brand})</span> - {(portion_kj/4.184).toFixed(1).toString().replace(".", ",")} kcal</p>
            </div>;
          });

          foodlogs.push(<div key={"1k"+i} style={{marginBottom:"12px"}}>
            <h5 style={{textAlign:"right"}}><span style={{opacity:".7"}}>{Object.keys(grouped)[i]}</span> {(total_kj/4.184).toFixed(1).toString().replace(".", ",")} kcal</h5>
            {food_items}
          </div>);
        }
      } else {
        foodlogs.push(<div key={"2k"}><p style={{opacity:".5"}}>Voeg je eerste eetregistratie toe.</p></div>);
      }
    }

      foodlog_card = <div className="card">
        <div className="index-actions">
          <button className="btn btn-e btn-fat" onClick={() => openModal(this, null, null, "modal_create_foodlog_open")}>nieuwe voedingregistratie</button>
          {foodlog_data !== undefined && foodlog_data.data !== undefined && foodlog_data.data[0] !== undefined && <button className="btn btn-e btn-fat" onClick={() => openModal(this, null, null, "crud_modal_foodlog_open")}>beheren</button>}
        </div>{foodlogs}<ModalCreateFoodlog shouldShow={this.state.modal_create_foodlog_open} close={() => closeModal(this, "modal_create_foodlog_open")} /><ModalCRUD config={config} shouldShow={this.state.crud_modal_foodlog_open} close={() => closeModal(this, "crud_modal_foodlog_open")} delete api_block="foodlog_list" empty_text='Klik op "nieuwe registratie" om je eerste registratie toe te voegen.' main_property="food_grams" main_property_formatting="g" sub_property="date" sub_property_formatting="date_d-ml-y" api_endpoint_delete="/foodlog" api_block_ref="food_list" api_block_ref_id="food_id" ref_main_property="name" /></div>;

    // if(food_data !== undefined) {
    //   let foods = [];
    //   if(food_data.data[0] !== undefined) {
    //     for(let i = 0; i < 3; i++) {
    //       let item = food_data.data[i];

    //       if(item !== undefined) {
    //         foods.push(<div key={"2k"+i} style={{marginBottom:"12px"}}>
    //           <div><small>Productnaam</small> {item.name}</div>
    //           <div><small>Merk</small> {item.brand}</div>
    //         </div>);
    //       }
    //     }
    //   }
    //   let food_left = null;
    //   if(food_data.data.length > 3) {
    //     let szl = food_data.data.length - 3;
    //     food_left = "+ "+szl+" producten.";
    //   }
    //   food_card = <div className="card">
    //     <div className="index-actions">
    //     </div>{foods}<div><small style={{opacity:".6"}}>{food_left}</small></div></div>;
    // }

    return (
      <div className="container" ref={this.setWrapperRef} style={{marginTop:"2em"}}>
        {foodlog_data !== undefined && foodlog_data.data !== undefined && foodlog_data.data[0] === undefined && foodlog_introcard}
        {foodlog_card}
        {food_card}
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Food)



// WEBPACK FOOTER //
// ./src/containers/Food.js